import validate from "/home/runner/work/atlantic/atlantic/agents/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/atlantic/atlantic/agents/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "holding-agreements": () => import("/home/runner/work/atlantic/atlantic/agents/middleware/holding-agreements.ts"),
  subscriptions: () => import("/home/runner/work/atlantic/atlantic/agents/middleware/subscriptions.ts"),
  "utility-connect": () => import("/home/runner/work/atlantic/atlantic/agents/middleware/utility-connect.ts")
}